import VideoRow from "../components/VideoRow";
import VideoCard from "../components/VideoCard";
import Reveal from "../components/Reveal";
import ClientMarquee from "../components/ClientMarquee";
import SEO from "../components/SEO";
import { HOME_ROWS, ALL_HOME_VIDEOS, THUMBS } from "../data/content";

// VideoObject schema for the videos shown on this page, gives Google permission to
// surface our video thumbnails in search results (big CTR win for a video co.)
const videoListJsonLd = {
  "@context": "https://schema.org",
  "@graph": ALL_HOME_VIDEOS.map((v) => ({
    "@type": "VideoObject",
    name: `${v.client} — ${v.title}`,
    description: `${v.title} video produced by Yellow Video Production Liverpool for ${v.client}.`,
    thumbnailUrl: THUMBS[v.id] || `https://vumbnail.com/${v.id}.jpg`,
    uploadDate: "2024-01-01",
    contentUrl: `https://vimeo.com/${v.id}${v.h ? `/${v.h}` : ""}`,
    embedUrl: `https://player.vimeo.com/video/${v.id}${v.h ? `?h=${v.h}` : ""}`,
    publisher: { "@id": "https://www.yellowvideoproduction.com/#organization" },
    inLanguage: "en-GB",
  })),
};

export default function Showreel() {
  return (
    <main className="pt-28 pb-20" data-testid="showreel-page">
      <SEO
        title="Showreel | Video Production Liverpool | Yellow"
        description="Yellow Video Production's showreel, case studies from brands, charities, universities and government agencies, across Liverpool and the UK."
        path="/showreel"
        keywords="video production showreel liverpool, yellow video production showreel, video portfolio liverpool, video production examples liverpool, brand video showreel uk"
        jsonLd={videoListJsonLd}
        breadcrumbs={[
          { name: "Home", path: "/" },
          { name: "Showreel", path: "/showreel" },
        ]}
      />
      <section className="yv-container">
        <Reveal>
          <p className="yv-eyebrow">Video Production Liverpool · Showreel</p>
          <h1 className="yv-h1 mt-3 max-w-4xl">
            Check out some of our<br />previous videos.
          </h1>
          <p className="text-white/70 max-w-2xl mt-5 text-lg leading-relaxed">
            A selection of films <strong className="text-white">Yellow Video Production's work</strong> have made for brands, charities, universities and government agencies, click any thumbnail to play.
          </p>
        </Reveal>
      </section>

      <ClientMarquee />

      {/* Featured row mirrors home page Recent Work */}
      <section className="yv-container !mt-12">
        <VideoRow
          title={HOME_ROWS.recent.title}
          eyebrow="Featured"
          videos={HOME_ROWS.recent.videos}
          testId="showreel-row-featured"
        />
      </section>

      {/* Full case-study grid: every home-page video */}
      <section className="yv-container !mt-8">
        <Reveal>
          <p className="yv-eyebrow">Case studies</p>
          <h2 className="yv-h2 text-white mt-2">All projects</h2>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-10">
          {ALL_HOME_VIDEOS.map((v) => (
            <Reveal key={v.id}>
              <article className="bg-white/[0.02] border border-white/10 rounded-md overflow-hidden" data-testid={`showreel-case-${v.id}`}>
                <VideoCard video={v} />
                <div className="p-6">
                  <p className="yv-eyebrow text-[10px] mb-2">{v.client}</p>
                  <h3 className="yv-h3 text-white">{v.title}</h3>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </section>
    </main>
  );
}
